"use client";

import { useEffect } from "react";

/**
 * Sabit (sticky) üst header'ın gerçek yüksekliğini ölçüp `--sf-header-h`
 * CSS değişkenine yazar. Duyuru çubuğu açık/kapalı olduğunda yükseklik
 * değiştiği için, sticky offset'ler (örn. sepet Sipariş Özeti) bu değeri
 * referans alır ve header'ın altına tam oturur.
 *
 * Yalnızca header gerçekten sticky iken render edilir; aksi halde değişken
 * set edilmez ve tüketiciler küçük bir fallback offset kullanır.
 */
export function StickyHeaderHeight({ targetId }: { targetId: string }) {
  useEffect(() => {
    const el = document.getElementById(targetId);
    if (!el) return;

    const root = document.documentElement;
    const update = () => root.style.setProperty("--sf-header-h", `${el.offsetHeight}px`);

    update();
    const ro = new ResizeObserver(update);
    ro.observe(el);
    window.addEventListener("resize", update);

    return () => {
      ro.disconnect();
      window.removeEventListener("resize", update);
      root.style.removeProperty("--sf-header-h");
    };
  }, [targetId]);

  return null;
}
